import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';
import { Helmet } from 'react-helmet';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Helmet>
      <title>TECH HUB YOKOHAMA | 横浜市技術系スタートアップ成長支援拠点</title>
      <meta name="description" content="TECH HUB YOKOHAMAは、研究者・技術者人口の多さ、グローバル企業の集積といった横浜の強みを生かし、横浜市が推進する脱炭素に資するGXやモビリティをはじめとする技術系分野でのユニコーン・クラスのスタートアップ創出を目指した技術系に特化した交流拠点です。" />

      <meta property="og:title" content="TECH HUB YOKOHAMA | 横浜市技術系スタートアップ成長支援拠点" />
      <meta
        property="og:description"
        content="TECH HUB YOKOHAMAは、研究者・技術者人口の多さ、グローバル企業の集積といった横浜の強みを生かし、横浜市が推進する脱炭素に資するGXやモビリティをはじめとする技術系分野でのユニコーン・クラスのスタートアップ創出を目指した技術系に特化した交流拠点です。"
      />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="/assets/images/coWorkingLogo_M.png" />
      <meta property="og:url" content="https://techhub-yokohama.com" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="TECH HUB YOKOHAMA | 横浜市技術系スタートアップ成長支援拠点" />
      <meta
        name="twitter:description"
        content="TECH HUB YOKOHAMAは、研究者・技術者人口の多さ、グローバル企業の集積といった横浜の強みを生かし、横浜市が推進する脱炭素に資するGXやモビリティをはじめとする技術系分野でのユニコーン・クラスのスタートアップ創出を目指した技術系に特化した交流拠点です。"
      />
      <meta name="twitter:image" content="/assets/images/coWorkingLogo_M.png" />

    </Helmet>
    <App />
  </React.StrictMode>
);
